import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";


export default function AdminCustomerProfileView() {
  const { id } = useParams();        // ✅ در سطح بالای کامپوننت
  const navigate = useNavigate();    // ✅ در سطح بالای کامپوننت
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/user-login/");
        return;
      }

      if (!id) {
        console.warn("No profile id provided in route params");
        navigate("/admin/users/");
        return;
      }

      try {
        const response = await api.get(`/accounts/admin-customer-profiles/${id}/`);
        setProfile(response.data);
      } catch (error) {
        console.error("خطا در گرفتن پروفایل:", error);
        if (error.response?.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          navigate("/login/");
        } else if (error.response?.status === 404) {
          alert("پروفایل پیدا نشد");
          navigate("/admin/users/");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id, navigate]);

  if (loading) {
    return <div className="text-center py-8">در حال بارگذاری...</div>;
  }

  if (!profile) {
    return <div className="text-center py-8 text-red-500">پروفایل یافت نشد</div>;
  }

  const renderField = (label, value) => (
    <div className="flex flex-col sm:flex-row sm:justify-between py-3 border-gray-200">
      <span className="text-[#1E3A5F] font-semibold mb-1 sm:mb-0">{label}:</span>
      <span className="text-[#1E3A5F] text-right">
        {value || <span className="text-red-500">تکمیل نشده</span>}
      </span>
    </div>
  );

  const renderSection = (title, fields) => (
    <div className="mb-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4 border-b pb-2">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields}
      </div>
    </div>
  );

  return (


      <div className="p-6 max-w-4xl mx-auto bg-white rounded-xl shadow-lg">
        {/* هدر پروفایل */}
        <div className="flex items-center gap-6 mb-8 pb-6 border-b border-gray-200">
          <div className="relative">
            <img
              src={profile.profile_picture || "/images/default-avatar.png"}
              alt="پروفایل"
              className="w-24 h-24 rounded-full object-cover border-4 border-blue-100"
            />
          </div>
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-gray-800">کد مشتری: {profile.customer_code}</h1>
            <p className="text-gray-600 mt-2 text-lg leading-relaxed">
              {profile.description || "من یک صاحب ایده هستم. تمام تلفن خود را دارم انجام می‌دهم که خدمتی شایسته به خودم، خانواده‌ام و جامعه‌ام انجام دیم."}
            </p>
          </div>
        </div>

        {/* تب‌های فرضی */}
        <div className="flex gap-8 mb-8 border-b border-gray-200">
          <button className="pb-4 px-2 border-b-2 border-blue-600 text-blue-600 font-medium">پروفایل</button>
          <button className="pb-4 px-2 text-gray-500 hover:text-gray-700 font-medium">آدرس‌ها</button>
          <button className="pb-4 px-2 text-gray-500 hover:text-gray-700 font-medium">حساب‌های بانکی</button>
        </div>

        {/* مشخصات کاربر */}
        {renderSection("مشخصات کاربر", [
          renderField("نام و نام خانوادگی", profile.full_name),
          renderField("شماره موبایل", profile.user?.phone_number),
          renderField("ایمیل", profile.email),
          renderField("کد ملی", profile.national_id),
          renderField("تاریخ تولد", profile.birth_date),
          renderField("شماره موبایل دوم", profile.secondary_phone),
          renderField("وضعیت احراز هویت", profile.kyc_status === "verified" ? "تأیید شده" : "تأیید نشده"),
        ])}

        {/* مشخصات سازمان - در صورت حقوقی بودن */}
        {profile.is_legal_entity && renderSection("مشخصات سازمان", [
          renderField("نام سازمان", profile.org_name),
          renderField("کد اقتصادی", profile.economic_code),
          renderField("شناسه ملی", profile.national_legal_id),
          renderField("شماره ثبت", profile.registration_id),
          renderField("استان", profile.province),
          renderField("شهر", profile.city),
          renderField("تلفن ثابت", profile.office_phone),
          renderField("مدیر عامل / نماینده", profile.representative_name),
          renderField("شماره موبایل مدیر عامل", profile.representative_phone),
          renderField("ایمیل سازمانی", profile.org_email),
        ])}

        {/* دکمه‌های اقدام */}
        <div className="flex gap-4 mt-8 pt-6 border-t border-gray-200">

          <button
            onClick={() => navigate("/admin-panel/user-management/")}
            className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors font-medium"
          >
            بازگشت به پنل
          </button>
        </div>
      </div>
  );
};

